import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új incidens',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "incidentRegistrationDescription",
                label: "Incidens leírása (jellege)",
                formSize: 3,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "risk",
                label: "Kockázat",
                formSize: 3,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "technicalProtection",
                label: "Megfelelő technikai védelem",
                formSize: 3,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "possibleConsequences",
                label: "Valószínűsíthető következmények",
                formSize: 3,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "privacyOfficerId",
                label: "Adatvédelmi tisztviselő",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "contactPersonId",
                label: "Kapcsolattartó",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "siteId",
                label: "Telephely ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "userId",
                label: "Érintett felhasználó",
                sort: true,
                formType: 'select',
                formSize: 3,
                visibility: false,
                formRequired: true,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "userTypeId",
                label: "Érintett alkalmazott típus",
                sort: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getUserPersonTypeFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                visibility: false,
                formRequired: true,
                formVisible: false
            },
            {
                name: "incidentRegistrationDescription",
                label: "Incidens leírása (jellege)",
                sort: true,
                formType: 'text',
                formSize: 6,
                formRequired: true,
                formVisible: true
            },
            {
                name: "risk",
                label: "Kockázat",
                sort: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "technicalProtection",
                label: "Megfelelő technikai védelem",
                sort: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "possibleConsequences",
                label: "Valószínűsíthető következmények",
                sort: true,
                formType: 'text',
                formSize: 6,
                formRequired: true,
                formVisible: true
            },
            {
                name: "privacyOfficer.personName",
                label: "Adatvédelmi tisztviselő",
                visibility: true,
                formVisible: false
            },
            {
                name: "privacyOfficerId",
                label: "Adatvédelmi tisztviselő",
                visibility: false,
                formSize: 3,
                formType: 'select',
                formVisible: true,
                formRequired: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "contactPerson.personName",
                label: "Kapcsolattartó",
                visibility: true,
                formVisible: false,
            },
            {
                name: "contactPersonId",
                label: "Kapcsolattartó",
                visibility: false,
                formSize: 3,
                formType: 'select',
                formVisible: true,
                formRequired: true,
                selectOptions: {
                    apiCallback: Api.getGdprPersonFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "suggestedActions",
                label: "Javasolt teendők",
                formType: 'text',
                visibility: false,
                formSize: 6,
                formRequired: true,
                formVisible: true
            },
            {
                name: "toBeNotified",
                label: "Értesítendők",
                visibility: false,
                formType: 'text',
                formSize: 6,
                formRequired: true,
                formVisible: true
            },
            {
                name: "personalData",
                label: "Érintett személyes adatok",
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllIncidentRegistrationPersonalDataFilter,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                visibility: false,
                formVisible: true,
                formRequired: true
            },
            {
                name: "noInformation",
                label: "Nem kell tájékoztatás (34/3/a,d,c,)",
                visibility: false,
                formSize: 3,
                formType: 'checkbox',
                formVisible: true
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ]
    }
}
